import { useAuth } from "../../../../api/auth/useAuth";
import { contractFields } from "../fields/contractFields";

export const useContractFields = () => {
  const { isAdmin } = useAuth();

  if (isAdmin) {
    return contractFields;
  }

  return contractFields.filter((f) => !f.role || f.role === "user");
};
